import styled from 'styled-components';
import { ScreenSize } from '../../../../enums';

export const Links = styled.div`
	box-sizing: border-box;
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin: 0 -10px;

	@media (max-width: ${ScreenSize.medium}) {
		flex-direction: column;
	}
`;
